import { render } from "./Join.vue?vue&type=template&id=54667dda&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"

import "./Join.vue?vue&type=style&index=0&id=54667dda&scoped=true&lang=css"

import exportComponent from "E:\\vueWeb\\official\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54667dda"]])

export default __exports__